












































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
@Component({})
export default class Home extends Vue {
  private icon = false;
  private puntos: any = null;

  private mounted() {
    this.getPuntos();
  }
  private servicio1() {
    this.$router.push({ name: "Erradicacion" }).catch(err => {});
  }

  private servicio2() {
    this.$router.push({ name: "Bateas" }).catch(err => {});
  }

  private servicio3() {
    this.$router.push({ name: "Recoleccion" }).catch(err => {});
  }

  private getPuntos() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    axios
      .get("puntos")
      .then(res => {
        let base = process.env.VUE_APP_BASE_URL;
        this.puntos = res.data;
        if (this.puntos.mobile && this.puntos.mobile != "") {
          this.puntos.mobile = base + this.puntos.mobile;
        }
        if (this.puntos.desktop && this.puntos.desktop != "") {
          this.puntos.desktop = base + this.puntos.desktop;
        }
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        this.puntos = null;
      });
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }
}
